import { CSSProperties, FC } from 'react'
import { Image } from 'antd-mobile'
import styles from './styles.module.css'
import CustomButton from './CustomButton'
import ImageBaker from '../../assets/image_baker.png'
import { useTheme } from "../../features/hooks";

const ToggleSelector: FC<{
  options: Array<any>,
  onChange: Function,
  value: any,
  backgroundVar: string,
  buttonBackgroundVar: string,
  buttonActiveBackgroundVar: string,
  colorVar: string,
  activeColorVar: string,
  isFit?: boolean,
  styles?: CSSProperties
}> = props => {
  const { theme } = useTheme()
  
  return <div style={{
    display: 'flex',
    flexDirection: 'row',
    height: '36px',
    padding: '2px',
    borderRadius: '20px',
    boxShadow: '1px 1px 3px 0px rgba(0, 0, 0, 0.25)',
    background: `var(${props.backgroundVar})`,
    boxSizing: 'border-box',
    gap: '2px',
    ...props.styles
  }}>
    {
      props.options.map((option, index) => (
        <CustomButton
          key={'ts_cb_' + index}
          text={option.text}
          onClick={() => { props.onChange(option.value) }}
          height={'32px'}
          minWidth={props.isFit ? undefined : '134px'}
          paddingHorizontal={props.isFit ? '15px' : undefined}
          style={{ textWrap: 'nowrap' }}
          fontWeight={'400'}
          fontSize={'14.5px'}
          backgroundVar={(option.value === props.value) ? props.buttonActiveBackgroundVar : props.buttonBackgroundVar }
          colorVar={(option.value === props.value) ? props.activeColorVar : props.colorVar }
          prependImage={option.prependImage}
          prependImageInvert={
            !(theme === 'light' || (option.value === props.value))
          }
          prependImageMargin={option.prependImageMargin}
          prependImageWidth={option.prependImageWidth}
          prependImageHeight={option.prependImageHeight}
        />
      ))
    }
  </div>
}


export default ToggleSelector
